import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import styles from './NoticeTab.module.scss'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { Pagination } from './Pagination'
import { SortBar } from './SortBar'
import { useNoticeList } from '../../hooks'

export const NoticeTab = () => {
	const { data: notices, isLoading, error } = useNoticeList()
	const [openId, setOpenId] = useState(null)
	const [isNewestFirst, setIsNewestFirst] = useState(true)
	const [currentPage, setCurrentPage] = useState(1)

	const itemsPerPage = 10

	const sortedNotices = notices
		? [...notices].sort((a, b) => {
				const dateA = new Date(a.date)
				const dateB = new Date(b.date)
				return isNewestFirst ? dateB - dateA : dateA - dateB
			})
		: []

	const totalPages = Math.ceil(sortedNotices.length / itemsPerPage)
	const currentItems = sortedNotices.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage,
	)

	const toggle = (id) => {
		setOpenId((prev) => (prev === id ? null : id))
	}

	return (
		<div className={styles.noticePanel}>
			<SortBar
				isNewestFirst={isNewestFirst}
				onToggle={() => setIsNewestFirst((prev) => !prev)}
			/>

			<div className={styles.noticeWrapper}>
				{isLoading ? (
					<p className={styles.loading}>로딩 중...</p>
				) : error ? (
					<p className={styles.emptyState}>공지사항을 불러오는데 실패했습니다.</p>
				) : notices?.length === 0 ? (
					<p className={styles.emptyState}>공지사항이 없습니다.</p>
				) : (
					<>
						<ul className={styles.noticeList}>
							{currentItems.map((notice) => (
								<li key={notice.id} className={styles.noticeItem}>
									<div
										className={styles.noticeHeader}
										onClick={() => toggle(notice.id)}>
										<div className={styles.noticeLabel}>
											<span className={styles.noticeId}>{notice.id}</span>
											<span className={styles.noticeTitle}>
												{notice.title}
											</span>
										</div>
										<div className={styles.noticeMeta}>
											<span className={styles.noticeDate}>{notice.date}</span>
											{openId === notice.id ? (
												<ChevronUpIcon className={styles.noticeIcon} />
											) : (
												<ChevronDownIcon className={styles.noticeIcon} />
											)}
										</div>
									</div>
									{openId === notice.id && (
										<div className={styles.noticeContent}>
											<div className={styles.divider}></div>
											<div className={styles.markdownContent}>
												<ReactMarkdown
													remarkPlugins={[remarkGfm]}
													rehypePlugins={[rehypeRaw]}
													remarkRehypeOptions={{ passThrough: ['link'] }}>
													{notice.content}
												</ReactMarkdown>
											</div>
										</div>
									)}
								</li>
							))}
						</ul>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</>
				)}
			</div>
		</div>
	)
}
